import React, { memo, useContext } from 'react'
import PropTypes from 'prop-types'

import { Icon } from '../index'
import { util } from '../../../util'
import { LanguageContext } from '../../../context/LanguageContext'

const DoubleChevron = ({
    iconSize,
    backwardClickHandler,
    forwardClickHandler,
    forwardDisabled = false,
    backwardDisabled = false,
    renderContent,
    display = 'inline',
    className,
    gap = 'lg',
}) => {
    //RtL
    const { rtl } = useContext(LanguageContext)

    //ClassNames
    const chevronClass = util.joinClasses('double-chevron', gap && `${gap}-gap`, className)

    //Render
    return (
        <div className={chevronClass} data-testid={'double-chevron'}>
            <Icon
                display={display}
                className={`double-chevron__${rtl ? 'forward-icon' : 'backward-icon'}`}
                size={iconSize}
                pointer={!backwardDisabled && true}
                onClick={backwardClickHandler}
                disabled={backwardDisabled}
                color={backwardDisabled ? 'disable' : null}
                renderIcon={rtl ? util.ArrowForwardIosIcon : util.ArrowBackIosIcon}
                data-testid={'double-chevron__backward-icon'}
            />
            {renderContent ? (
                <div className={'double-chevron__content'}>{renderContent()}</div>
            ) : null}
            <Icon
                display={display}
                className={`double-chevron__${rtl ? 'backward-icon' : 'forward-icon'}`}
                size={iconSize}
                pointer={!forwardDisabled && true}
                onClick={forwardClickHandler}
                disabled={forwardDisabled}
                color={forwardDisabled ? 'disable' : null}
                renderIcon={rtl ? util.ArrowBackIosIcon : util.ArrowForwardIosIcon}
                data-testid={'double-chevron__forward-icon'}
            />
        </div>
    )
}

DoubleChevron.propTypes = {
    iconSize: PropTypes.oneOf(['xxxs', 'xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
    backwardClickHandler: PropTypes.func,
    forwardClickHandler: PropTypes.func,
    forwardDisabled: PropTypes.bool,
    backwardDisabled: PropTypes.bool,
    renderContent: PropTypes.func,
    display: PropTypes.oneOf(['inline', 'block', 'inline-block']),
    className: PropTypes.string,
    gap: PropTypes.oneOf(['md', 'lg']),
}

export default memo(DoubleChevron)
